/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireSummary } from './CustomQuestionnaireSummary';
import {
  CustomQuestionnaireSummaryFromJSON,
  CustomQuestionnaireSummaryFromJSONTyped,
  CustomQuestionnaireSummaryToJSON,
} from './CustomQuestionnaireSummary';
import type { UseCaseName } from './UseCaseName';
import { UseCaseNameFromJSON, UseCaseNameFromJSONTyped, UseCaseNameToJSON } from './UseCaseName';

/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireAnswerSetSummary
 */
export interface CustomQuestionnaireAnswerSetSummary {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerSetSummary
   */
  readonly id: number;
  /**
   *
   * @type {UseCaseName}
   * @memberof CustomQuestionnaireAnswerSetSummary
   */
  readonly useCase: UseCaseName;
  /**
   *
   * @type {CustomQuestionnaireSummary}
   * @memberof CustomQuestionnaireAnswerSetSummary
   */
  readonly questionnaire: CustomQuestionnaireSummary;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireAnswerSetSummary
   */
  readonly createdBy: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireAnswerSetSummary
   */
  readonly updatedBy: string;
  /**
   *
   * @type {Date}
   * @memberof CustomQuestionnaireAnswerSetSummary
   */
  readonly createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof CustomQuestionnaireAnswerSetSummary
   */
  readonly updatedAt: Date;
  /**
   *
   * @type {boolean}
   * @memberof CustomQuestionnaireAnswerSetSummary
   */
  isDraft?: boolean;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerSetSummary
   */
  lastConfirmedStep?: number | null;
}

/**
 * Check if a given object implements the CustomQuestionnaireAnswerSetSummary interface.
 */
export function instanceOfCustomQuestionnaireAnswerSetSummary(
  value: object,
): value is CustomQuestionnaireAnswerSetSummary {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('questionnaire' in value) || value['questionnaire'] === undefined) return false;
  if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
  if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireAnswerSetSummaryFromJSON(json: any): CustomQuestionnaireAnswerSetSummary {
  return CustomQuestionnaireAnswerSetSummaryFromJSONTyped(json, false);
}

export function CustomQuestionnaireAnswerSetSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireAnswerSetSummary {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    useCase: UseCaseNameFromJSON(json['use_case']),
    questionnaire: CustomQuestionnaireSummaryFromJSON(json['questionnaire']),
    createdBy: json['created_by'],
    updatedBy: json['updated_by'],
    createdAt: new Date(json['created_at']),
    updatedAt: new Date(json['updated_at']),
    isDraft: json['is_draft'] == null ? undefined : json['is_draft'],
    lastConfirmedStep: json['last_confirmed_step'] == null ? undefined : json['last_confirmed_step'],
  };
}

export function CustomQuestionnaireAnswerSetSummaryToJSON(
  value?: Omit<
    CustomQuestionnaireAnswerSetSummary,
    'id' | 'useCase' | 'questionnaire' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    is_draft: value['isDraft'],
    last_confirmed_step: value['lastConfirmedStep'],
  };
}
